import { systemLoop } from './content.js'

export function SystemLoop() {
  return (
    <section className="system-loop section" id="system">
      <div className="shell">
        <div className="loop-header">
          <div>
            <p className="eyebrow">Illustrative target flow</p>
            <h2>One continuous money path.</h2>
          </div>
          <div className="loop-legend">
            <span><i className="legend-value" /> Value moves forward</span>
            <span><i className="legend-proof" /> Evidence returns</span>
          </div>
        </div>

        <div className="loop-diagram">
          <div className="loop-track" aria-hidden="true">
            <span className="loop-track-line loop-track-value" />
            <span className="loop-track-line loop-track-proof" />
            <span className="loop-signal loop-signal-value" />
            <span className="loop-signal loop-signal-proof" />
          </div>
          <ol className="loop-stations">
            {systemLoop.map((item) => (
              <li
                className={`loop-station station-${item.tone}`}
                key={item.key}
              >
                <div className="station-marker">
                  <span>{item.index}</span>
                  <i />
                </div>
                <div className="station-copy">
                  <span>{item.plane}</span>
                  <strong>{item.name}</strong>
                  <p>{item.summary}</p>
                  <small>{item.boundary}</small>
                </div>
              </li>
            ))}
          </ol>
          <div className="loop-caption">
            <span>Reserve and policy enter the path</span>
            <strong>Final settlement becomes a portable receipt</strong>
          </div>
        </div>
      </div>
    </section>
  )
}
